// Hearting / un-hearting one pose on the favorites gallery. Un-hearting clears
// a "Favorite All" press: a family that pressed it and then removed poses did
// not favorite everything, and recordFavoriteSelection reports that press.
export function toggleFavorite({ favorites, usedFavoriteAll }, id) {
  if (favorites.includes(id)) {
    return { favorites: favorites.filter((item) => item !== id), usedFavoriteAll: false };
  }
  return { favorites: [...favorites, id], usedFavoriteAll };
}

export default toggleFavorite;
